import axios from "axios";
import React, { useState } from "react";
import { useEffect } from 'react';

// COMPONENTS
import EventsStatus from '../EventsStatus/EventsStatus';
import TodaysEvents from '../TodaysEvents/TodaysEvents';

// STYLES
import './Events.scss';

//#region UTILS
import { formatDate } from '../../../core/utils';
import { endpoints } from '../../../core/constants';
//#endregion

export default function Events() {
    const [events, setEvents] = useState<object>({});
    const headers = {
        //'cache': 'default',
        'mode': 'cors',
        'credentials': 'include',
        'content-type': 'application/json'
    };

    // GET EVENTS ONLY ONCE ON FIRST LOAD
    useEffect(() => {       
        var dateLessOneDay = new Date();
        dateLessOneDay.setDate(dateLessOneDay.getDate()-1);
        console.log("up events: ", endpoints.incidents + "?active=1&open_date=" + formatDate(dateLessOneDay));
        axios.get(endpoints.incidents + "?active=1&open_date=" + formatDate(dateLessOneDay), { headers: headers, withCredentials: true })
            .then(response => {
                console.log(response.data.result);
                setEvents(response.data.result);
            });
    }, []);

    return (
        <div className='Events'>
            <div className='Events__container'>
                <div className='Events__left'>
                    <TodaysEvents todayEvents={events} />
                </div>
                <div className='Events__right'>
                    <EventsStatus eventStatus={events} />
                </div>
            </div>
        </div>
    );
}